import { render } from "./UsersWinnerListPage.vue?vue&type=template&id=2cb8b63a&ts=true"
import script from "./UsersWinnerListPage.vue?vue&type=script&lang=ts"
export * from "./UsersWinnerListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__